import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import "../../style.css";
import Avatar from "../../../assets/images/DefaultProfilePic.jpg";
import { CButton } from "@coreui/react";
import { MdVerifiedUser } from "react-icons/md";
import { RxCrossCircled } from "react-icons/rx";
import { HiUserCircle } from "react-icons/hi2";

import { block_unblock_user, getUserDetail } from "../actions";
import ProperSpinner from "../../../components/spinner/ProperSpinner";
import CustomModal from "../../../components/customModal";

/**
 * @function UserDetails
 * @description for Details of specific
 * @returns JSX for User Details Page
 */

const UserDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [userDetails, setUserDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);

  const modalClose = () => {
    setModal(false);
  };

  const getUser = () => {
    dispatch(
      getUserDetail(`?userId=${id}`, (response) => {
        setUserDetails(response);
        setLoading(false);
      }),
    );
  };

  const block_unblock_handler = (_id, status) => {
    setLoading(true);
    if (status === 1) {
      dispatch(
        block_unblock_user({ status: 2 }, `?userId=${_id}`, (response) => {
          if (response.isSuccess) {
            setUserDetails((prev) => ({ ...prev, status: 2 }));
          }
          setLoading(false);
        }),
      );
    } else {
      dispatch(
        block_unblock_user({ status: 1 }, `?userId=${_id}`, (response) => {
          if (response.isSuccess) {
            setUserDetails((prev) => ({ ...prev, status: 1 }));
          }
          setLoading(false);
        }),
      );
    }
    modalClose();
  };

  const renderModalBody = (status) => {
    return (
      <div>
        <p>
          Are you sure want to{" "}
          <span className="highlight--text">
            {status === 1 ? "Block" : "Unblock"}
          </span>{" "}
          this user?{" "}
        </p>
      </div>
    );
  };
  useEffect(() => {
    setLoading(true);
    getUser();
  }, []);

  if (loading) {
    return <ProperSpinner />;
  } else
    return (
      <div className="user-details-main-container">
        <div className="user-details-container-1 ">
          <figure className="image-container rm--image--container">
            {userDetails?.profileImage ? (
              <img
                src={userDetails.profileImage}
                alt="Profile Photo"
                className="image rm--image"
              />
            ) : (
              <HiUserCircle className="image rm--image color--secondary" />
            )}
          </figure>
          <p className="label-text email-text">{userDetails?.email || "N/A"}</p>

          <div className="btn-container">
            <div
              className={` user-details-btns ${userDetails?.profileCompleted ? "success-btn" : "warning-btn"} px-0`}
            >
              {"Profile Completed"}
              {userDetails?.profileCompleted ? (
                <MdVerifiedUser className="lg-icon" />
              ) : (
                <RxCrossCircled className="lg-icon" />
              )}
            </div>

            {userDetails && userDetails.status && (
              <div
                onClick={() => setModal(true)}
                className={`site-details-btns ${userDetails?.status === 2 ? "site-success-btn" : "site-warning-btn"}`}
              >
                {userDetails.status === 1 ? "Block" : "Unblocked"}
                {userDetails?.status === 2 ? (
                  <MdVerifiedUser className="lg-icon" />
                ) : (
                  <RxCrossCircled className="lg-icon" />
                )}
              </div>
            )}
          </div>
        </div>

        <div className="user-details-container-2 ">
          {/* Profile Section */}
          <div className="personal-info-container">
            <h4 className="label-text heading text-underline ">
              {"Personal Information"}
            </h4>
            <div className="info-child-container ">
              <div className="info-sub-child-container">
                <p className="non-label-text">{"First Name"}</p>
                <p className="label-text info-text">
                  {userDetails?.firstName || "N/A"}
                </p>
              </div>
              <div className="info-sub-child-container">
                <p className="non-label-text">{"Last Name"}</p>
                <p className="label-text info-text">
                  {userDetails?.lastName || "N/A"}
                </p>
              </div>
            </div>
            <div className="info-child-container ">
              <div className="info-sub-child-container">
                <p className="non-label-text">{"Email Address"}</p>
                <p className="label-text info-text">
                  {userDetails?.email}{" "}
                  {/* <CButton
                    size="sm"
                    disabled
                    color={userDetails?.emailVerify ? "success" : "warning"}
                    variant="outline"
                    shape="rounded-pill"
                    className="d-flex justify-content-center  align-items-center gap-1 verification-btn"
                  >
                    {"Email Verified"}
                    {userDetails?.emailVerify ? (
                      <MdVerifiedUser />
                    ) : (
                      <RxCrossCircled />
                    )}
                  </CButton> */}
                </p>
              </div>
              <div className="info-sub-child-container">
                <p className="non-label-text">{"Phone Number"}</p>
                <p className="label-text info-text">
                  {userDetails?.phoneNo ?? "N/A"}
                  {/* <CButton
                    size="sm"
                    disabled
                    color={userDetails?.phoneVerify ? "success" : "warning"}
                    variant="outline"
                    shape="rounded-pill"
                    className="d-flex justify-content-center  align-items-center gap-1 verification-btn "
                  >
                    {"phoneNoVerified"}
                    {userDetails?.phoneVerify ? (
                      <MdVerifiedUser />
                    ) : (
                      <RxCrossCircled />
                    )}
                  </CButton> */}
                </p>
              </div>
            </div>
            <div className="info-child-container ">
              <div className="info-sub-child-container">
                <p className="non-label-text">{"DOB"}</p>
                <p className="label-text info-text">
                  {userDetails?.dateOfBirth || "N/A"}
                </p>
              </div>
              <div className="info-sub-child-container">
                <p className="non-label-text">{"Country Code"}</p>
                <p className="label-text info-text">
                  {userDetails.countryCode || "N/A"}
                </p>
              </div>
            </div>

            <div className="info-child-container ">
              <div className="info-sub-child-container">
                <p className="non-label-text">{"Country"}</p>
                <p className="label-text info-text">
                  {userDetails.country || "N/A"}
                </p>
              </div>
              <div className="info-sub-child-container" />
            </div>
          </div>
        </div>
        <CustomModal
          visible={modal}
          visibleHandler={modalClose}
          heading={"Confirmation"}
          body={() => renderModalBody(userDetails?.status)}
          confirmHandler={() =>
            block_unblock_handler(userDetails?._id, userDetails?.status)
          }
          modalSize="md"
          confirmText={
            userDetails?.status === 1 ? "Yes, Block" : "Yes, Unblock"
          }
          footershow={true}
          closeText="Cancel"
        />
      </div>
    );
};

export default UserDetails;
